import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import appReducer from './app';
import { reduxLogger } from './middleware/redux-logger';

export const store = configureStore({
  reducer: {
    app: appReducer,
  },
  middleware: [...getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }), reduxLogger],
});
